export enum AuthStatus {
  USER_OK = 'USER_OK',
  USER_NOT_REGISTERED = 'USER_NOT_REGISTERED',
  EMAIL_NOT_VALID = 'EMAIL_NOT_VALID',
  PHONE_NUMBER_MISSING = 'PHONE_NUMBER_MISSING',
  PHONE_NUMBER_NOT_VALID = 'PHONE_NUMBER_NOT_VALID',
}
